import { render, staticRenderFns } from "./cenerateStatement.vue?vue&type=template&id=393bdc54&scoped=true&"
import script from "./cenerateStatement.vue?vue&type=script&lang=js&"
export * from "./cenerateStatement.vue?vue&type=script&lang=js&"
import style0 from "./cenerateStatement.vue?vue&type=style&index=0&id=393bdc54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393bdc54",
  null
  
)

export default component.exports